import { useNavigate } from 'react-router-dom';

export default function ProductCard({ product }) {
  const navigate = useNavigate();

  const conditionBadge = {
    'New': '#2ecc71',
    'NOS': '#3498db',
    'Used – Normal Use': '#e67e22',
    'Used – Fair': '#e74c3c'
  };

  return (
    <div
      style={styles.card}
      onClick={() => navigate(`/product/${product._id}`)}
    >
      <div style={styles.imageBox}>
        {product.images?.[0]
          ? <img src={product.images[0]} alt={product.title} style={styles.image} />
          : <div style={styles.noImage}>No Image</div>
        }
        <span style={{ ...styles.badge, background: conditionBadge[product.condition] || '#888' }}>
          {product.condition}
        </span>
      </div>
      <div style={styles.body}>
        <p style={styles.category}>{product.partCategory}</p>
        <h3 style={styles.title}>{product.title}</h3>
        {product.fitment?.length > 0 && (
          <p style={styles.fitment}>
            {product.fitment[0].make} {product.fitment[0].model} · {product.fitment[0].yearFrom}–{product.fitment[0].yearTo}
          </p>
        )}
        <p style={styles.price}>${product.price.toLocaleString('en-CA', { minimumFractionDigits: 2 })}</p>
      </div>
    </div>
  );
}

const styles = {
  card: { border: '1px solid #e0e0e0', borderRadius: 8, overflow: 'hidden', background: '#fff', cursor: 'pointer', transition: 'box-shadow .2s' },
  imageBox: { position: 'relative', background: '#f5f5f5', height: 180, display: 'flex', alignItems: 'center', justifyContent: 'center' },
  image: { width: '100%', height: '100%', objectFit: 'cover' },
  noImage: { color: '#aaa', fontSize: 14 },
  badge: { position: 'absolute', top: 8, left: 8, color: '#fff', fontSize: 11, padding: '3px 8px', borderRadius: 4, fontWeight: 600 },
  body: { padding: '12px 16px' },
  category: { fontSize: 11, color: '#888', textTransform: 'uppercase', letterSpacing: 1, margin: '0 0 4px' },
  title: { fontSize: 15, fontWeight: 600, margin: '0 0 6px', lineHeight: 1.3 },
  fitment: { fontSize: 12, color: '#555', margin: '0 0 8px' },
  price: { fontSize: 18, fontWeight: 700, color: '#111', margin: 0 }
};